<div class="fund-invest">
  <h3 class="ds-title-3">{{ 'sp.accountDetails2.invest.title' | translate }}</h3>
  @if (currentAccount.kind !== '3a' || (currentAccount.kind === '3a' && isPossibleToCreate3A)) {
    <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'sp.accountDetails2.invest.subtitle' | translate }}</p>
  }
  @if (currentAccount.kind === 'kid') {
    <app-ds-callout
      variant="warning"
      customIcon="triangle-alert"
      [description]="'sp.accountDetails2.invest.kidWarning' | translate: { ownerName: ownerName }"
    ></app-ds-callout>
  }

  @if (currentAccount.kind === '3a') {
    @if (isPossibleToCreate3A) {
      <app-ds-callout
        variant="info"
        [title]="'sp.accountDetails2.qr.3aPossibleDeposit.title' | translate: { amount: stillPossibleToInvest | thousand: currentAccount.currency }"
        [description]="'sp.accountDetails2.qr.3aPossibleDeposit.description' | translate"
      ></app-ds-callout>
    } @else {
      <app-ds-callout
        variant="warning"
        customIcon="triangle-alert"
        [description]="'sp.accountDetails2.qr.3aPossibleDeposit.transferOnly' | translate"
      ></app-ds-callout>
    }
  }

  @if (currentAccount.kind !== '3a' || (currentAccount.kind === '3a' && isPossibleToCreate3A)) {
    <div class="fund-invest-header">
      <div>
        <h4 class="ds-heading-2">{{ 'sp.accountDetails2.qr.title' | translate }}</h4>
      </div>
      <div>
        <h4 class="ds-heading-2">{{ 'sp.accountDetails2.manual.title' | translate }}</h4>
      </div>
    </div>

    <div class="fund-invest-details">
      <div class="fund-invest-code">
        <h4 class="ds-heading-2">{{ 'sp.accountDetails2.qr.title' | translate }}</h4>

        <div class="fund-invest-qr">
          <div class="fund-qr-wrap" [class.is-kid-acc]="currentAccount.kind === 'kid'" #fundQrWrap>
            <div class="fund-qr" [innerHTML]="currentAccount.deposit_qr_code | safeHtml"></div>
          </div>

          <div class="fund-qr-details" #fundQrDetails>
            <div class="fund-qr-dropdown">
              <div class="fund-qr-btn" (click)="toggleDetails()">
                <p class="ds-caption-1">{{ 'sp.accountDetails2.qr.usage.title' | translate }}</p>
                <app-ds-icon size="icon-size-2" [name]="showDetails ? 'chevron-up' : 'chevron-down'"></app-ds-icon>
              </div>

              @if (showDetails) {
                <div class="fund-qr-info">
                  <div>
                    <app-ds-rounded-icon size="small" variant="info" icon="focus"></app-ds-rounded-icon>
                    <p class="ds-ui-3">{{ 'sp.accountDetails2.qr.usage.' + (isAndroid ? 'android' : 'ios') | translate }}</p>
                  </div>

                  <div>
                    <app-ds-rounded-icon size="small" variant="info" icon="smartphone"></app-ds-rounded-icon>
                    <p class="ds-ui-3">{{ 'sp.accountDetails2.qr.usage.desc2' | translate }}</p>
                  </div>

                  <div>
                    <app-ds-rounded-icon size="small" variant="info" icon="qr-code"></app-ds-rounded-icon>
                    <p class="ds-ui-3">{{ 'sp.accountDetails2.qr.usage.desc3' | translate }}</p>
                  </div>
                </div>
                <p class="ds-ui-3 ds-color-core-neutral-8">{{ 'sp.accountDetails2.qr.usage.notice' | translate }}</p>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="fund-invest-manual">
        <h4 class="ds-heading-2">{{ 'sp.accountDetails2.manual.title' | translate }}</h4>

        <div class="fund-invest-info">
          <div class="ds-rows-white">
            @if (currentAccount.kind === '3a') {
              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'sp.accountDetails2.qr.3a.paymentFor' | translate }}</p>
                    <p class="ds-heading-3">{{ 'sp.accountDetails2.qr.3a.paymentForAddress' | translate }}</p>
                  </div>
                  <div>
                    <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation('hypiAddress')"></app-ds-icon>
                  </div>
                </div>
              </div>

              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'sp.accountDetails2.qr.3a.inFavour' | translate }}</p>
                    <p class="ds-heading-3">{{ 'sp.accountDetails2.qr.3a.inFavourAddress' | translate }}</p>
                  </div>
                  <div>
                    <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation('libertyAddress')"></app-ds-icon>
                  </div>
                </div>
              </div>

              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'sp.accountDetails2.qr.3a.account' | translate }}</p>
                    <p class="ds-heading-3 break-long-iban">{{ currentAccount.liberty_account.qr_iban }}</p>
                  </div>
                  <div>
                    <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation(currentAccount.liberty_account.qr_iban)"></app-ds-icon>
                  </div>
                </div>
              </div>

              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'sp.accountDetails2.qr.3a.referenceNumber' | translate }}</p>
                    <p class="ds-heading-3">{{ currentAccount.liberty_account.reference_number }}</p>
                  </div>
                  <div>
                    <app-ds-icon
                      name="copy"
                      size="icon-size-3"
                      (click)="copyInformation(currentAccount.liberty_account.reference_number)"
                    ></app-ds-icon>
                  </div>
                </div>
              </div>
            } @else {
              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">IBAN</p>
                    <p class="ds-heading-3">{{ currentAccount.iban | iban }}</p>
                  </div>
                  <div>
                    <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation(currentAccount.iban)"></app-ds-icon>
                  </div>
                </div>
              </div>

              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">SWIFT / BIC</p>
                    <p class="ds-heading-3">{{ 'steps.id5.saxo_funded.swiftBic' | translate }}</p>
                  </div>
                  <div>
                    <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation('swift')"></app-ds-icon>
                  </div>
                </div>
              </div>

              <div class="ds-row-white extra-padding">
                <div class="content">
                  <div>
                    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'sp.revamp.accountDetailsPage.bankDetails' | translate }}</p>
                    <p class="ds-heading-3">{{ 'reinvest.bankAddress' | translate }}</p>
                  </div>
                  <div>
                    <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation('address')"></app-ds-icon>
                  </div>
                </div>
              </div>
              @if (currentAccount.kind !== 'kid') {
                <div class="ds-row-white extra-padding">
                  <div class="content">
                    <div>
                      <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'reinvest.beneficiary' | translate }}</p>
                      <p class="ds-heading-3">{{ ownerName }}</p>
                    </div>
                    <div>
                      <app-ds-icon name="copy" size="icon-size-3" (click)="copyInformation(ownerName)"></app-ds-icon>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="fund-invest-notice">
      <h4 class="ds-heading-2">{{ 'sp.accountDetails2.qr.depositDelayNote.title' | translate }}</h4>
      <p class="ds-ui-2 ds-color-core-neutral-8">
        {{ 'sp.accountDetails2.qr.depositDelayNote.description' | translate }}
        <a class="ds-ui-2 ds-color-core-neutral-8" (click)="onOpenHelp()">{{
          'sp.accountDetails2.qr.depositDelayNote.descriptionLink' | translate
        }}</a>
      </p>
    </div>
  }

  @if (currentAccount.kind === '3a') {
    <div class="fund-3a">
      <div class="fund-3a-header" (click)="toggle3aTransferDetails()">
        <div>
          <app-ds-rounded-icon variant="info" icon="repeat"></app-ds-rounded-icon>
          <p class="ds-heading-2">{{ 'sp.accountDetails2.qr.3aTransfer.toggle' | translate }}</p>
        </div>
        <app-ds-icon size="icon-size-3" [name]="show3aTransferDetails ? 'chevron-up' : 'chevron-down'"></app-ds-icon>
      </div>

      @if (show3aTransferDetails) {
        <div class="fund-3a-content">
          <p class="ds-ui-1">{{ 'sp.accountDetails2.qr.3aTransfer.stepsTitle' | translate }}</p>
          <ul>
            <li class="ds-ui-2">{{ 'sp.accountDetails2.qr.3aTransfer.step1' | translate }}</li>
            <li class="ds-ui-2">{{ 'sp.accountDetails2.qr.3aTransfer.step2' | translate }}</li>
            <li class="ds-ui-2">{{ 'sp.accountDetails2.qr.3aTransfer.step3' | translate }}</li>
          </ul>
          <app-ds-button icon="arrow-down-to-line" variant="outline" width="auto" [disabled]="transfer3ADoc.length === 0" (click)="onDownloadForm()">
            {{ 'sp.accountDetails2.qr.3aTransfer.btn' | translate }}
          </app-ds-button>
          <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'sp.accountDetails2.qr.3aTransfer.notice' | translate }}</p>
        </div>
      }
    </div>
  }
</div>
